import React from "react";
import Background from "../Background";
import StaticPageTable from "./StaticPageTable";

const StaticPageManagement = () => {
  return (
    <Background heading={"StaticPage Management"} key="staticpage-management">
      <StaticPageTable length={30} />
    </Background>
  );
};

export default StaticPageManagement;
